module.exports = __webpack_public_path__ + "img/small-1-mob.78db4ed9.jpg";